module.exports = __webpack_public_path__ + "static/media/main-image.c2f4461c.png";